import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronDownSm = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M16 10.5L12 14.5L8 10.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronDownSm.js.map